import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import NaviBarv2_En from "./Components/NaviBarv2_En";
import Footer_En from "./Components/Footer_En";
import { Container, Row, Col, Card, Badge, Button, Alert } from "react-bootstrap";

const DOCS_BASE =
  (process.env.REACT_APP_API_URL || "http://localhost:8001").replace(/\/$/, "") +
  "/api/documents";
const ACCENT = "#198754";

const CARD_BODY =
  "d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center gap-3";

const numStyle = {
  width: 32,
  height: 32,
  borderRadius: "50%",
  background: ACCENT,
  color: "#fff",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: 14,
  marginBottom: 10,
};

const noteStyle = {
  background: "#e8f3ec",
  color: "#1b5e37",
  borderRadius: 4,
};

const PAY_STEPS = [
  {
    n: 1,
    title: "Obtain the Expert Review",
    text:
      "Obtain the Expert Review certificate for the article (see the instructions in the «Expert Review» tab).",
    note: "Without the ER the request will not be accepted.",
  },
  {
    n: 2,
    title: "Get an invoice from the journal",
    text: "Request an invoice from the journal. Provide the payer details.",
    note: "For a publication in an international journal a Russian translation of the invoice is required.",
  },
  {
    n: 3,
    title: "Fill out the purchase request",
    text: "Fill out the «Purchase request» form: cost center, budget, purpose, amount.",
    note: "Use the template and example below.",
  },
  {
    n: 4,
    title: "Fill out the order",
    text: "Fill out the «Order» form — approval of payment via the agent.",
    note: "Use the template and example below.",
  },
  {
    n: 5,
    title: "Submit the document package",
    text: "Collect the package and send it by email: glc@siriusuniversity.ru",
    note: "Make sure all documents are signed.",
  },
];

const PAY_EXAMPLES = [
  {
    icon: "📄",
    name: "Purchase request — filled example",
    desc: "See how the form is filled out",
    file: "example-purchase-request.pdf",
  },
  {
    icon: "📄",
    name: "Order — filled example",
    desc: "See how the form is filled out",
    file: "example-order.pdf",
  },
];

const PAY_TEMPLATES = [
  {
    icon: "📊",
    name: "Purchase request",
    desc: "File to fill out in Excel",
    file: "template-purchase-request.xlsx",
    download: "Шаблон Заявка на закупку.xlsx",
  },
  {
    icon: "📄",
    name: "Order",
    desc: "File to fill out in Word",
    file: "template-order.docx",
    download: "Шаблон Поручение.docx",
  },
];

function PublicationPayment_En() {
  return (
    <div className="App">
      <NaviBarv2_En />

      <Container className="py-4 text-start">
        <div className="text-center mb-5">
          <h1 className="fw-bold mb-2">Article Publication Payment</h1>
          <p className="text-muted mb-2">
            Sirius University — the process of paying for the publication of a
            scientific article in an international journal
          </p>
          <Badge bg="success" className="fs-6 px-3 py-2">
            Publication payment document package
          </Badge>
        </div>

        <section className="mb-5">
          <h2
            className="fw-bold pb-2 mb-4"
            style={{ borderBottom: `2px solid ${ACCENT}` }}
          >
            Procedure
          </h2>
          <Row className="g-3">
            {PAY_STEPS.map((s) => (
              <Col key={s.n} md={6} lg={4}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body>
                    <div style={numStyle}>{s.n}</div>
                    <h3 className="h6 fw-bold">{s.title}</h3>
                    <p className="text-muted small mb-2">{s.text}</p>
                    <div className="small px-2 py-1" style={noteStyle}>
                      {s.note}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <Alert variant="success" className="mt-3 mb-2 text-start">
            <strong>📧 Where to send:</strong> glc@siriusuniversity.ru
          </Alert>
          <Alert variant="warning" className="mb-0 text-start">
            <strong>Package contents:</strong> purchase request, scan of the
            Expert Review, article and translation (for a foreign journal),
            invoice and translation (for a foreign journal), order.
          </Alert>
        </section>

        <section className="mb-5">
          <h2
            className="fw-bold pb-2 mb-4"
            style={{ borderBottom: `2px solid ${ACCENT}` }}
          >
            📋 Filled examples
          </h2>
          <h3 className="h5 fw-bold mb-3" style={{ color: ACCENT }}>
            📊 Filled example documents
          </h3>
          <Row className="g-3">
            {PAY_EXAMPLES.map((e, i) => (
              <Col key={i} md={6}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body className={CARD_BODY}>
                    <div>
                      <div className="fw-semibold">
                        {e.icon} {e.name}
                      </div>
                      <div className="text-muted small">{e.desc}</div>
                    </div>
                    <Button
                      variant="outline-success"
                      href={`${DOCS_BASE}/payment/${e.file}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-nowrap text-center flex-shrink-0"
                    >
                      View PDF
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </section>

        <section className="mb-5">
          <h2
            className="fw-bold pb-2 mb-4"
            style={{ borderBottom: `2px solid ${ACCENT}` }}
          >
            📄 Templates to fill out
          </h2>
          <h3 className="h5 fw-bold mb-3" style={{ color: ACCENT }}>
            📎 Download templates
          </h3>
          <Row className="g-3">
            {PAY_TEMPLATES.map((t, i) => (
              <Col key={i} md={6}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body className={CARD_BODY}>
                    <div>
                      <div className="fw-semibold">
                        {t.icon} {t.name}
                      </div>
                      <div className="text-muted small">{t.desc}</div>
                    </div>
                    <Button
                      variant="success"
                      href={`${DOCS_BASE}/payment/${t.file}`}
                      download={t.download}
                      className="text-nowrap text-center flex-shrink-0"
                    >
                      📥 Download
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <Alert variant="info" className="mt-3 mb-0 text-start">
            <strong>🧾 Payer details for the invoice (for foreign journals):</strong>
            <pre
              className="mt-2 mb-1 p-3 rounded"
              style={{
                background: "#f8f5f0",
                border: "1px solid #d8d2c2",
                whiteSpace: "pre-wrap",
                fontFamily: "Consolas, monospace",
                fontSize: 13,
                color: "#1b2a4a",
              }}
            >
              {`ANDREY MOSKALEV
AVA AXONA D.O.O. BEOGRAD (PIB 113624345)
DANILA LEKICA-SPANCA 1/2 BEOGRAD, NOVI BEOGRAD
11070, BELGRADE SERBIA`}
            </pre>
            <div className="text-muted small">
              These details are provided in your personal account when requesting
              an invoice from the publisher.
            </div>
          </Alert>
        </section>

        <Alert variant="info" className="mb-0 text-start">
          <strong>ℹ️ Note:</strong> After the request is approved in 1C, the
          procurement department takes the request into work. All documents must
          be signed by authorized persons.
        </Alert>
      </Container>

      <Footer_En />
    </div>
  );
}

export default PublicationPayment_En;
